import { render, staticRenderFns } from "./AIQnaChatPanel.vue?vue&type=template&id=c40a958c&scoped=true&"
import script from "./AIQnaChatPanel.vue?vue&type=script&lang=js&"
export * from "./AIQnaChatPanel.vue?vue&type=script&lang=js&"
import style0 from "./AIQnaChatPanel.vue?vue&type=style&index=0&id=c40a958c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c40a958c",
  null
  
)

export default component.exports